import { render, staticRenderFns } from "./facebook-callback.vue?vue&type=template&id=34172284&scoped=true&"
import script from "./facebook-callback.vue?vue&type=script&lang=js&"
export * from "./facebook-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34172284",
  null
  
)

export default component.exports